import Vue from "vue";
import VueRouter from "vue-router";
import { isSetting } from "@/common/sbase.js";
import { getUserAgentInfo } from "@/common/utils.js";
window.$ua = getUserAgentInfo();

Vue.use(VueRouter);

const routes = [
  {
    path: "/pc",
    name: "pc",
    component: () => import("@/views/Pc.vue"),
    beforeEnter: (to, from, next) => {
      if (!isSetting && document.documentElement.clientWidth < 768) {
        next(to.fullPath.replace(/\/pc\//, "/wap/"));
      } else {
        next();
      }
    },
    children: [
      {
        path: "fileList",
        name: "PcFileList",
        props: route => ({
          folderId: route.query.folderId
        }),
        component: () => import("@/views/pc/FileList.vue"),
        meta: { title: "文件列表" }
      },
      {
        path: "fileDetail",
        name: "PcFileDetails",
        props: route => ({
          fileId: route.query.fileId
        }),
        component: () => import("@/views/pc/PcFileDetails.vue"),
        meta: { title: "文件详情" }
      },
      {
        path: "filePreview",
        name: "FilePreview",
        props: route => ({
          fileId: route.query.fileId
        }),
        component: () => import("@/components/FilePreview.vue")
      }
    ]
  },
  {
    path: "/wap",
    name: "wap",
    component: () => import("@/views/Wap.vue"),
    beforeEnter: (to, from, next) => {
      if (!isSetting && document.documentElement.clientWidth >= 768) {
        next(to.fullPath.replace(/\/wap\//, "/pc/"));
      } else {
        next();
      }
    },
    children: [
      {
        path: "fileList",
        name: "WapFileList",
        props: route => ({
          folderId: route.query.folderId
        }),
        component: () => import("@/views/wap/FileList.vue"),
        meta: { title: "文件列表" }
      },
      {
        path: "fileDetail",
        name: "WapFileDetails",
        props: route => ({
          fileId: route.query.fileId
        }),
        component: () => import("@/views/wap/WapFileDetails.vue"),
        meta: { title: "文件详情" }
      },
      {
        path: "tips",
        name: "weChatTip",
        component: () => import("@/views/wap/weChatTip.vue"),
        meta: { title: window.$ua.isWeChat ? "请在浏览器中打开" : "文件下载" }
      },
      {
        path: "filePreview",
        name: "FilePreview",
        props: route => ({
          fileId: route.query.fileId
        }),
        component: () => import("@/components/FilePreview.vue")
      }
    ]
  },
  
];

const router = new VueRouter({
  // mode: 'history',
  routes
});
router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "文件";
  });
});
export default router;
